import React, { useContext } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-core';
import BrowserHistory from '../utils/BrowserHistory';
import RouterPaths from '../../common/RouterPaths';
import { UserRoles } from '@amzn/awscat-pattern-library-service-model';
import constants from '../../common/constants';

const HeaderManageDropdown = () => {
  const appContext = useContext(AppContext);
  const userProfile = appContext?.authnInfo?.userProfile;

  const handleManageClick = (event: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
    const eventId = event.detail.id;
    switch (eventId) {
      case constants.PERMISSIONS:
        BrowserHistory.push(RouterPaths.ADMIN_USER_PERMISIONS);
        break;
      case constants.MANAGE_POSTS:
        BrowserHistory.push(RouterPaths.MANAGE_POSTS);
        break;
      default:
        break;
    }
  };

  const dropDownItems = [];
  if (userProfile?.roles?.has(UserRoles.Admin) || userProfile?.roles?.has(UserRoles.TechWriter)) {
    if (userProfile?.roles.has(UserRoles.Admin)) {
      dropDownItems.push({ text: constants.PERMISSIONS, id: constants.PERMISSIONS });
    }
    dropDownItems.push({ text: constants.MANAGE_POSTS, id: constants.MANAGE_POSTS });
  }

  if (!dropDownItems.length) {
    return null;
  }
  return (
    <ButtonDropdown items={dropDownItems} onItemClick={handleManageClick}>
      Manage
    </ButtonDropdown>
  );
};

export default HeaderManageDropdown;
